import { APIResponseModel, EnumAPIStatus, IAPIResponse } from '@api/AbstractAPI';
import { IBalanceCampaignClosing, IBalanceHistoryItem } from '@models/Balance';
import { Injectable } from '@angular/core';
import { WebService } from './web.service';
import { IDashboardResult } from '@models/Dashboard';
import { IFilterList } from '@models/Content';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private modules;

    /** MOCK: closing date per campaign (lost on reload) */
    private mockClosedCampaigns: { [idCampaign: string]: string } = {};

    constructor(private WebService: WebService) { }

    /**
     * MOCK: closing state of a campaign. Replace the body by the WebService request when the endpoint is available.
     * @param idCampaign
     * @returns
     */
    public async GetCampaignClosing(idCampaign: string): Promise<IAPIResponse<IBalanceCampaignClosing>> {

        const closedDate = this.mockClosedCampaigns[idCampaign] || null;

        return new APIResponseModel<IBalanceCampaignClosing>({
            Status: EnumAPIStatus.Success,
            IsSuccessStatus: true,
            Result: { IsClosed: !!closedDate, ClosedDate: closedDate }
        });
    }

    /**
     * MOCK: closes the campaign (action that must happen before the reversal).
     * Replace the body by the WebService request when the endpoint is available.
     * @param idCampaign
     * @returns
     */
    public async CloseCampaign(idCampaign: string): Promise<IAPIResponse<any>> {

        await new Promise(resolve => setTimeout(resolve, 400));

        this.mockClosedCampaigns[idCampaign] = new Date().toISOString();

        return new APIResponseModel<any>({
            Status: EnumAPIStatus.Success,
            IsSuccessStatus: true,
            Result: true
        });
    }


    /**
     *
     * @param isToReturnCampaignBalances
     * @returns
     */
    public async GetEntityBalance(isToReturnCampaignBalances: boolean = true) {

        const response = await this.WebService.GetEntityBalance(isToReturnCampaignBalances);

        return response;
    }

    /**
     * MOCK: history of the campaign balance. Replace the body by the WebService request when the endpoint is available;
     * the response keeps the shape of an API response.
     * @param idCampaign 
     * @returns 
     */
    public async GetEntityBalanceHistory(idCampaign: string): Promise<IAPIResponse<IBalanceHistoryItem[]>> {

        const total = 2;
        const users = ['Ana Silva', 'Rui Costa', 'Marta Pinto'];

        const all: IBalanceHistoryItem[] = Array.from({ length: total }, (_, i) => ({
            Id: `${idCampaign}-${i + 1}`,
            CreateDate: new Date(Date.now() - i * 36 * 60 * 60 * 1000).toISOString(),
            Description: i % 4 == 3 ? 'Estorno parcial' : 'Estorno de saldo',
            User: users[i % users.length],
            Amount: `${(25 + (i * 17) % 180).toFixed(2).replace('.', ',')} €`
        }));

        await new Promise(resolve => setTimeout(resolve, 400));

        return new APIResponseModel<IBalanceHistoryItem[]>({
            Status: EnumAPIStatus.Success,
            IsSuccessStatus: true,
            Result: all
        });
    }

    /**
     *
     * @param idCampaign
     * @param amount
     * @returns
     */
    public async EntityBalanceReversal(idCampaign: string, amount: number) {

        const response = await this.WebService.EntityBalanceReversal(idCampaign, amount);

        return response;
    }

    /**
     * SIBS: adds an amount to the client wallet balance (mock)
     * @param amount
     * @returns
     */
    public async EntityBalanceWalletTransfer(amount: number) {

        const response = await this.WebService.EntityBalanceWalletTransfer(amount);

        return response;
    }


    /**
     * 
     * @param formData 
     * @returns 
     */
    public async UploadAndGetUrl(formData: FormData) {

        const response = await this.WebService.UploadAndGetUrl(formData);

        return response;
    }


    /**
     * 
     * @param idEdition 
     * @returns 
     */
    public async GetDashboardData(idEdition: string): Promise<IAPIResponse<IDashboardResult>> {

        const response = await this.WebService.GetDashboardData(idEdition);

        return response;
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    public async GetDashboardStatistics(filters): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetDashboardStatistics(filters);

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetGenreList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetGenreList();

        return response;
    }


    public async GetEntity(id: string): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntity(id);

        return response;
    }
    /**
     * 
     * @returns 
     */
    public async GetEntityList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntityList();

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetEntityConfiguration(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntityConfiguration();

        return response;
    }

    /**
     *
     * @returns
     */
    public async EntityForcingSync(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.EntityForcingSync();

        return response;
    }
    /**
     * 
     * @param text 
     * @param idContinent 
     * @returns 
     */
    public async GetCountryList(text: string = "", idContinent: number = null): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetCountryList(text, idContinent);

        return response;
    }

    /**
     * 
     * @param idCampaing 
     * @param filters 
     * @returns 
     */
    public async GetBlackListItemList(idCampaing, filters = null): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetBlackListItemList(idCampaing, filters);

        return response;
    }

    /**
     * 
     */
    public async GetContentTypeList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetContentTypeList();

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetAvailableWalletModuleList() {

        if (this.modules) return Promise.resolve(this.modules);

        const response = await this.WebService.GetAvailableWalletModuleList();

        this.modules = response;

        return response;
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    public async RequestList(filters: IFilterList) {

        const response = await this.WebService.RequestList(filters);

        return response;
    }
}
